
export interface TimezoneOption {
  value: string;
  label: string;
}

export const timezones: TimezoneOption[] = [
  { value: "Pacific/Midway", label: "(UTC-11:00) Midway Island, Samoa" },
  { value: "Pacific/Honolulu", label: "(UTC-10:00) Hawaii" },
  { value: "America/Anchorage", label: "(UTC-09:00) Alaska" },
  { value: "America/Los_Angeles", label: "(UTC-08:00) Pacific Time (US & Canada)" },
  { value: "America/Denver", label: "(UTC-07:00) Mountain Time (US & Canada)" },
  { value: "America/Chicago", label: "(UTC-06:00) Central Time (US & Canada)" },
  { value: "America/New_York", label: "(UTC-05:00) Eastern Time (US & Canada)" },
  { value: "America/Halifax", label: "(UTC-04:00) Atlantic Time (Canada)" },
  { value: "America/St_Johns", label: "(UTC-03:30) Newfoundland" },
  { value: "America/Argentina/Buenos_Aires", label: "(UTC-03:00) Buenos Aires" },
  { value: "Atlantic/Cape_Verde", label: "(UTC-01:00) Cape Verde Islands" },
  { value: "Europe/London", label: "(UTC+00:00) London, Dublin, Edinburgh" },
  { value: "Europe/Paris", label: "(UTC+01:00) Paris, Berlin, Rome, Madrid" },
  { value: "Europe/Helsinki", label: "(UTC+02:00) Helsinki, Athens, Istanbul" },
  { value: "Europe/Moscow", label: "(UTC+03:00) Moscow, St. Petersburg" },
  { value: "Asia/Dubai", label: "(UTC+04:00) Dubai, Abu Dhabi" },
  { value: "Asia/Karachi", label: "(UTC+05:00) Karachi, Islamabad" },
  { value: "Asia/Dhaka", label: "(UTC+06:00) Dhaka" },
  { value: "Asia/Bangkok", label: "(UTC+07:00) Bangkok, Jakarta" },
  { value: "Asia/Shanghai", label: "(UTC+08:00) Beijing, Shanghai, Hong Kong" },
  { value: "Asia/Tokyo", label: "(UTC+09:00) Tokyo, Osaka, Sapporo" },
  { value: "Australia/Sydney", label: "(UTC+10:00) Sydney, Melbourne" },
  { value: "Pacific/Noumea", label: "(UTC+11:00) New Caledonia" },
  { value: "Pacific/Auckland", label: "(UTC+12:00) Auckland, Wellington" },
  { value: "Pacific/Kiritimati", label: "(UTC+14:00) Kiritimati Island" }
];

export const getTimezoneLabel = (timezone: string): string => {
  // Find the timezone in our array
  const found = timezones.find(tz => tz.value === timezone);
  // Return the label if found, otherwise return the timezone string itself
  return found ? found.label : timezone;
};

export const getUserTimezone = (): string => {
  try {
    // Use the Intl API to get the user's timezone if possible
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (e) {
    // Fallback to default timezone
    return "America/New_York";
  }
};
